import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Grid, Button } from "@mui/material";
import LoaderWrapper from "../../../wrapper/LoaderWrapper";
import { useAsync } from "../../../../hooks/useAsync";
import usePaginationWithSearchParams from "../../../../hooks/usePaginationWithSearchParams";
import useDialog from "../../../../hooks/useDialog";
import TableService from "../../../../services/tableService";
import FilterTable from "../../../table/FilterTable";
import { useEmptyArrayMemo } from "../../../../hooks/useEmptyArrayMemo";
import { useSearchParams } from "react-router-dom";
import { centerVericalAlignIconStyle } from "../../../../helpers/styles";
import ControlPointOutlinedIcon from "@mui/icons-material/ControlPointOutlined";
import SearchButton from "../../../button/SearchButton/SearchButton";
import FilterDialog from "../../../base/FilterDialog";
import UniversalFilterForm from "../../../form/UniversalFilterForm";
import useDialogWithId from "../../../../hooks/useDialogWithId";
import useIcoService from "../../../../services/icoService";
import { INTEREST_TABLE_CONFIG } from "./TableConfig";
import InterestDialog from "../../../dialog/InterestDialog";


const InterestTab = (props) => {
  const { t } = useTranslation();
  const [interestsLocal, setInterestsLocal] = useState([]);
  const [countRecords, setCountRecords] = useState();
  const [searchParams] = useSearchParams();

  const { emptyArrayMemo } = useEmptyArrayMemo()

  const { getInterestList } = useIcoService();



  const [
    openInterestDialog,
    interestChangeId,
    onOpenInterestDialog,
    onCloseInterestDialog
  ] = useDialogWithId();



  const [openFilterDialog,
    onOpenFilterDialog,
    onCloseFilterDialog] =
    useDialog();

  const {
    page,
    pageSize,
    handleChangePageWithSearchParams,
    handleChangeRowsPerPage,
    resetPageNumber,
  } = usePaginationWithSearchParams();

  const interestData = useAsync(
    () => getInterestList(searchParams),
    [searchParams]
  );


  useEffect(() => {
    if (interestData.loading) {
      return;
    }
    setInterestsLocal(interestData.value.results);
    setCountRecords(interestData.value.count);
  }, [interestData.loading]);

  const isLoading = interestsLocal === undefined || props.filteringData.loading


  const handleOpenInterestDialog = useCallback(
    (e, interestId) => {
      e.stopPropagation();
      onOpenInterestDialog(interestId);
    },
    []
  );



  const data = React.useMemo(
    () =>

      TableService.getPreparedDataForCollapsibleTable(
        INTEREST_TABLE_CONFIG,
        interestsLocal ? interestsLocal : emptyArrayMemo,
        emptyArrayMemo,
        emptyArrayMemo,
        handleOpenInterestDialog
      ),

    [interestsLocal, INTEREST_TABLE_CONFIG]
  );

  const onCleanFlitersInFilterDialog = () => {
    setInterestsLocal(undefined);
    setCountRecords(undefined);
  };


  if (isLoading) return <LoaderWrapper showLoader={true} />;

  return (
    <Grid
      item
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      rowSpacing={1}
    >
      <Grid item xs={12} sm={2}>
        <Button
          fullWidth
          variant="contained"
          size="small"
          startIcon={<ControlPointOutlinedIcon sx={centerVericalAlignIconStyle} />}
          onClick={(e) => onOpenInterestDialog(undefined)}
        >
          {t("tabs.ico_admin_tabs.add_interest")}
        </Button>
      </Grid>
      <Grid item sm={9} />
      <Grid item xs={12} sm={1}>
        <SearchButton onClickSearch={onOpenFilterDialog} />
      </Grid>
      <Grid item xs={12}>
        <FilterTable
          data={data}
          showCheckbox={false}
          showCleanFilterIcon={true}
          countRecords={countRecords}
          page={page}
          onPageChange={handleChangePageWithSearchParams}
          rowsPerPage={pageSize}
          onRowsPerPageChange={handleChangeRowsPerPage}
          resetPageNumber={resetPageNumber}
          filteringData={props.filteringData}
          style={{ maxHeight: "vh" }}
          tableConfig={INTEREST_TABLE_CONFIG}
          showContextMenu={false}
          headersConfig={TableService.getHeadersConfigForCollapsibleTable(
            INTEREST_TABLE_CONFIG,
            props.filteringData || emptyArrayMemo,
            emptyArrayMemo,
            emptyArrayMemo,
          )}
        />
      </Grid>
      {openFilterDialog &&
        <FilterDialog
          open={openFilterDialog}
          onCleanFilters={onCleanFlitersInFilterDialog}
          onClose={onCloseFilterDialog}
          resetPageNumber={resetPageNumber}
          filterForm={
            <UniversalFilterForm
              filteringData={props.filteringData || emptyArrayMemo}
              filtersConfig={INTEREST_TABLE_CONFIG}
              includeOpenCloseFilter={false}
            />
          }
        />
      }
      {openInterestDialog &&
        <InterestDialog
          interestId={interestChangeId}
          open={openInterestDialog}
          onClose={onCloseInterestDialog}
          onRefetch={interestData.refetch}
        />

      }

    </Grid>
  );
};

InterestTab.propTypes = {
  filteringData: PropTypes.object,
};

InterestTab.defaultProps = {};

export default InterestTab;
